export const defaultStyleMap = {
    "EDITREGISTERRETURN": {
      "section": {
        "editableValues": {
          "backgroundColor": {
            "hex": "#013ff9",
            "opacity": 1,
            "puck": {
              "x": 288,
              "y": 15
            }
          },
          "spiral": {
            "visible": true,
            "gradient": {
              "type": "radial",
              "colorStops": [
                {
                  "hex": "#ffffff",
                  "puck": {
                    "x": 5,
                    "y": 1
                  },
                  "opacity": 0.9909638554216867,
                  "position": 0
                },
                {
                  "hex": "#ffffff",
                  "puck": {
                    "x": 7,
                    "y": 4
                  },
                  "opacity": 0.55,
                  "position": 1
                }
              ]
            }
          },
          "color": {
            "hex": "#000000",
            "opacity": 1,
            "puck": {
              "x": 6,
              "y": 208
            }
          }
        }
      },
      "header": {
        "editableValues": {
          "color": {
            "hex": "#0c0808",
            "opacity": 1,
            "puck": {
              "x": 86,
              "y": 179
            }
          }
        }
      },
      "orderNumber": {
        "editableValues": {
          "backgroundColor": {
            "hex": "#000000",
            "opacity": 0.4608433734939759,
            "puck": {
              "x": 0,
              "y": 0
            }
          },
          "border": "",
          "paddingX": "",
          "padding": ""
        },
        "extraClasses": {
          "autofill": {
            "backgroundClip": "",
            "webkit-text-fill-color": "",
            "boxShadow": "",
            "visible": false
          }
        }
      },
      "orderNumberText": {
        "editableValues": {
          "color": {
            "hex": "#000000",
            "opacity": 1,
            "puck": {
              "x": 25,
              "y": 207
            }
          },
          "backgroundColor": "",
          "border": "",
          "paddingX": "",
          "padding": ""
        },
        "extraClasses": {
          "error": {
            "color": "",
            "backgroundColor": "",
            "border": "",
            "visible": false
          }
        }
      },
      "orderNumberInput": {
        "editableValues": {
          "color": {
            "hex": "#ffffff",
            "opacity": 1,
            "puck": {
              "x": 9,
              "y": 2
            }
          },
          "backgroundColor": {
            "hex": "#ffffff",
            "opacity": 0,
            "puck": {
              "x": 0,
              "y": 0
            }
          },
          "border": ""
        },
        "extraClasses": {
          "autofill": {
            "backgroundClip": "",
            "webkit-text-fill-color": "",
            "boxShadow": "",
            "visible": false
          },
          "error": {
            "color": "",
            "backgroundColor": "",
            "visible": false
          }
        }
      },
      "email": {
        "editableValues": {
          "backgroundColor": {
            "hex": "#000000",
            "opacity": 0.4608433734939759,
            "puck": {
              "x": 0,
              "y": 0
            }
          },
          "border": "",
          "paddingX": "",
          "padding": ""
        },
        "extraClasses": {
          "autofill": {
            "backgroundClip": "",
            "webkit-text-fill-color": "",
            "boxShadow": "",
            "visible": false
          }
        }
      },
      "emailText": {
        "editableValues": {
          "color": {
            "hex": "#000000",
            "opacity": 1,
            "puck": {
              "x": 8,
              "y": 205
            }
          },
          "backgroundColor": "",
          "border": "",
          "paddingX": "",
          "padding": ""
        },
        "extraClasses": {
          "error": {
            "color": "",
            "backgroundColor": "",
            "border": "",
            "visible": false
          }
        }
      },
      "emailInput": {
        "editableValues": {
          "color": {
            "hex": "#ffffff",
            "opacity": 1,
            "puck": {
              "x": 7,
              "y": 1
            }
          },
          "backgroundColor": "",
          "border": ""
        },
        "extraClasses": {
          "autofill": {
            "backgroundClip": "",
            "webkit-text-fill-color": "",
            "boxShadow": "",
            "visible": false
          },
          "error": {
            "color": "",
            "backgroundColor": "",
            "visible": false
          }
        }
      },
      "requestReturnButton": {
        "editableValues": {
          "color": {
            "hex": "#ffffff",
            "opacity": 1,
            "puck": {
              "x": 4,
              "y": 10
            }
          },
          "backgroundColor": "",
          "border": ""
        },
        "extraClasses": {
          "hover": {
            "color": "",
            "backgroundColor": "",
            "border": "",
            "visible": false
          }
        }
      }
    },
    "EDITORDERLINESRETURN": {
      "section": {
        "editableValues": {
          "backgroundColor": {
            "hex": "#013ff9",
            "opacity": 1,
            "puck": {
              "x": 288,
              "y": 15
            }
          },
          "color": {
            "hex": "#000000",
            "opacity": 1,
            "puck": {
              "x": 6,
              "y": 208
            }
          },
          "spiral": {
            "visible": true,
            "gradient": {
              "type": "radial",
              "colorStops": [
                {
                  "hex": "#ffffff",
                  "puck": {
                    "x": 5,
                    "y": 1
                  },
                  "opacity": 0.9909638554216867,
                  "position": 0
                },
                {
                  "hex": "#ffffff",
                  "puck": {
                    "x": 7,
                    "y": 4
                  },
                  "opacity": 0.55,
                  "position": 1
                }
              ]
            }
          }
        }
      },
      "header": {
        "editableValues": {
          "color": ""
        }
      },
      "toReturnContainer": {
        "editableValues": {
          "backgroundColor": {
            "hex": "#000000",
            "opacity": 0.1,
            "puck": {
              "x": 10,
              "y": 207
            }
          },
          "color": {
            "hex": "#000000",
            "opacity": 1,
            "puck": {
              "x": 3,
              "y": 208
            }
          }
        }
      },
      "itemCanBeReturnedContainer": {
        "editableValues": {
          "backgroundColor": {
            "hex": "#ffffff",
            "opacity": 0.7951807228915663,
            "puck": {
              "x": 0,
              "y": 0
            }
          },
          "color": {
            "hex": "#000000",
            "opacity": 1,
            "puck": {
              "x": 3,
              "y": 208
            }
          }
        }
      },
      "itemAmountToReturnDropdown": {
        "editableValues": {
          "box": {
            "backgroundColor": {
              "hex": "#ffffff",
              "opacity": 1,
              "puck": {
                "x": 2,
                "y": 3
              }
            },
            "color": ""
          },
          "button": {
            "backgroundColor": {
              "hex": "#000000",
              "opacity": 1,
              "puck": {
                "x": 7,
                "y": 207
              }
            },
            "color": {
              "hex": "#ffffff",
              "opacity": 1,
              "puck": {
                "x": 3,
                "y": 3
              }
            }
          }
        }
      },
      "itemReasonToReturnDropdown": {
        "editableValues": {
          "box": {
            "backgroundColor": {
              "hex": "#ffffff",
              "opacity": 1,
              "puck": {
                "x": 2,
                "y": 3
              }
            },
            "color": ""
          },
          "button": {
            "backgroundColor": {
              "hex": "#000000",
              "opacity": 1,
              "puck": {
                "x": 7,
                "y": 207
              }
            },
            "color": {
              "hex": "#ffffff",
              "opacity": 1,
              "puck": {
                "x": 7,
                "y": 4
              }
            }
          }
        }
      },
      "itemToReturnRemarkInput": {
        "editableValues": {
          "color": {
            "hex": "#000000",
            "opacity": 1,
            "puck": {
              "x": 1,
              "y": 206
            }
          },
          "backgroundColor": "",
          "border": ""
        },
        "extraClasses": {
          "autofill": {
            "backgroundClip": "",
            "webkit-text-fill-color": "",
            "boxShadow": "",
            "visible": false
          },
          "error": {
            "color": "",
            "backgroundColor": "",
            "visible": false
          }
        }
      },
      "itemCanNotBeReturnedContainer": {
        "editableValues": {
          "backgroundColor": {
            "hex": "#ffffff",
            "opacity": 0.7951807228915663,
            "puck": {
              "x": 0,
              "y": 0
            }
          },
          "color": {
            "hex": "#000000",
            "opacity": 1,
            "puck": {
              "x": 3,
              "y": 208
            }
          }
        }
      },
      "toReturnFurtherDetails": {
        "editableValues": {
          "backgroundColor": {
            "hex": "#000000",
            "opacity": 0.1,
            "puck": {
              "x": 10,
              "y": 207
            }
          },
          "color": {
            "hex": "#000000",
            "opacity": 1,
            "puck": {
              "x": 3,
              "y": 208
            }
          }
        }
      },
      "createReturnButton": {
        "editableValues": {
          "color": {
            "hex": "#ffffff",
            "opacity": 1,
            "puck": {
              "x": 4,
              "y": 10
            }
          },
          "backgroundColor": "",
          "border": ""
        },
        "extraClasses": {
          "hover": {
            "color": "",
            "backgroundColor": "",
            "border": "",
            "visible": false
          }
        }
      }
    },
    "EDITORDERLINESCONFIRM": {
      "section": {
        "editableValues": {
          "backgroundColor": {
            "hex": "#013ff9",
            "opacity": 1,
            "puck": {
              "x": 288,
              "y": 15
            }
          },
          "color": {
            "hex": "#000000",
            "opacity": 1,
            "puck": {
              "x": 6,
              "y": 208
            }
          },
          "spiral": {
            "visible": true,
            "gradient": {
              "type": "radial",
              "colorStops": [
                {
                  "hex": "#ffffff",
                  "puck": {
                    "x": 5,
                    "y": 1
                  },
                  "opacity": 0.9909638554216867,
                  "position": 0
                },
                {
                  "hex": "#ffffff",
                  "puck": {
                    "x": 7,
                    "y": 4
                  },
                  "opacity": 0.55,
                  "position": 1
                }
              ]
            }
          }
        }
      },
      "toReturnContainer": {
        "editableValues": {
          "backgroundColor": {
            "hex": "#000000",
            "opacity": 0.1,
            "puck": {
              "x": 10,
              "y": 207
            }
          },
          "color": {
            "hex": "#000000",
            "opacity": 1,
            "puck": {
              "x": 3,
              "y": 208
            }
          }
        }
      },
      "lineContainer": {
        "editableValues": {
          "backgroundColor": {
            "hex": "#ffffff",
            "opacity": 0.7951807228915663,
            "puck": {
              "x": 0,
              "y": 0
            }
          },
          "color": {
            "hex": "#000000",
            "opacity": 1,
            "puck": {
              "x": 3,
              "y": 208
            }
          }
        }
      },
      "returnShipperContainer": {
        "editableValues": {
          "backgroundColor": {
            "hex": "#000000",
            "opacity": 0.1,
            "puck": {
              "x": 10,
              "y": 207
            }
          },
          "color": {
            "hex": "#000000",
            "opacity": 1,
            "puck": {
              "x": 3,
              "y": 208
            }
          }
        }
      },
      "returnShipperDetails": {
        "editableValues": {
          "backgroundColor": {
            "hex": "#ffffff",
            "opacity": 0.7951807228915663,
            "puck": {
              "x": 0,
              "y": 0
            }
          },
          "color": {
            "hex": "#000000",
            "opacity": 1,
            "puck": {
              "x": 3,
              "y": 208
            }
          }
        }
      },
      "previousStepButton": {
        "editableValues": {
          "color": {
            "hex": "#000000",
            "opacity": 1,
            "puck": {
              "x": 1,
              "y": 203
            }
          },
          "backgroundColor": {
            "hex": "#000000",
            "opacity": 0.1,
            "puck": {
              "x": 6,
              "y": 203
            }
          },
          "border": ""
        },
        "extraClasses": {
          "hover": {
            "color": "",
            "backgroundColor": "",
            "border": "",
            "visible": false
          }
        }
      },
      "confirmReturnButton": {
        "editableValues": {
          "color": {
            "hex": "#ffffff",
            "opacity": 1,
            "puck": {
              "x": 4,
              "y": 10
            }
          },
          "backgroundColor": {
            "hex": "#0f0f0f",
            "opacity": 1,
            "puck": {
              "x": 0,
              "y": 187
            }
          },
          "border": ""
        },
        "extraClasses": {
          "hover": {
            "color": "",
            "backgroundColor": "",
            "border": "",
            "visible": false
          }
        }
      }
    },
    "EDITRETURNSUBMITTED": {
      "section": {
        "editableValues": {
          "backgroundColor": {
            "hex": "#013ff9",
            "opacity": 1,
            "puck": {
              "x": 288,
              "y": 15
            }
          },
          "color": {
            "hex": "#000000",
            "opacity": 1,
            "puck": {
              "x": 6,
              "y": 208
            }
          },
          "spiral": {
            "visible": true,
            "gradient": {
              "type": "radial",
              "colorStops": [
                {
                  "hex": "#ffffff",
                  "puck": {
                    "x": 5,
                    "y": 1
                  },
                  "opacity": 0.9909638554216867,
                  "position": 0
                },
                {
                  "hex": "#ffffff",
                  "puck": {
                    "x": 7,
                    "y": 4
                  },
                  "opacity": 0.55,
                  "position": 1
                }
              ]
            }
          }
        }
      },
      "infoContainer": {
        "editableValues": {
          "backgroundColor": {
            "hex": "#000000",
            "opacity": 0.1,
            "puck": {
              "x": 10,
              "y": 207
            }
          },
          "color": {
            "hex": "#000000",
            "opacity": 1,
            "puck": {
              "x": 3,
              "y": 208
            }
          }
        }
      },
      "downloadLabelButton": {
        "editableValues": {
          "color": {
            "hex": "#ffffff",
            "opacity": 1,
            "puck": {
              "x": 4,
              "y": 10
            }
          },
          "backgroundColor": "",
          "border": ""
        },
        "extraClasses": {
          "hover": {
            "color": "",
            "backgroundColor": "",
            "border": "",
            "visible": false
          }
        }
      }
    },
    "RETURNSTATUSPAGE": {
      "section": {
        "editableValues": {
          "backgroundColor": {
            "hex": "#013ff9",
            "opacity": 1,
            "puck": {
              "x": 288,
              "y": 15
            }
          },
          "color": {
            "hex": "#000000",
            "opacity": 1,
            "puck": {
              "x": 6,
              "y": 208
            }
          },
          "spiral": {
            "visible": true,
            "gradient": {
              "type": "radial",
              "colorStops": [
                {
                  "hex": "#ffffff",
                  "puck": {
                    "x": 5,
                    "y": 1
                  },
                  "opacity": 0.9909638554216867,
                  "position": 0
                },
                {
                  "hex": "#ffffff",
                  "puck": {
                    "x": 7,
                    "y": 4
                  },
                  "opacity": 0.55,
                  "position": 1
                }
              ]
            }
          }
        }
      }
    },
    "DEFAULTDATA": {
      "savedColors": {
        "editableValues": {}
      }
    }
  }